import { UIIcon } from "./ui-icon";
import { UIIconName, UIIconVariant } from "./ui-icon-type";
import { useState } from "react";

import styles from "./ui-icon-button.module.css";
import { filterClasses } from "BEDROCK/utility/filter-classes";

interface UIIconButtonProps {
  iconName: UIIconName;
  onClick: () => void;
  width?: number;
  height?: number;
  padding?: number;
  isSelected?: boolean;
  className?: string;
  variant?: UIIconVariant; //If provided, will override the selected and highlighted variants.
  unclickable?: boolean; //Will not respond to clicks.
  disabled?: boolean; //Will not respond to clicks and will be greyed out.
}

export const UIIconButton = (props: UIIconButtonProps) => {
  const defaultSize = 40;
  const [isHovered, setIsHovered] = useState(false);

  const buttonVariant =
    props.variant ??
    (props.isSelected ? "SELECTED" : isHovered ? "HIGHLIGHTED" : "REGULAR");
  return (
    <button
      key={props.iconName}
      className={filterClasses(
        styles.button,
        props.className,
        props.isSelected && styles.selected,
        props.disabled && styles.disabled,
        props.unclickable && styles.unclickable
      )}
      onClick={props.onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: props.width ?? defaultSize,
        height: props.height ?? defaultSize,
        padding: props.padding ?? 0,
      }}
    >
      <UIIcon
        iconName={props.iconName}
        variant={buttonVariant}
        size={(props.width ?? defaultSize) - (props.padding ?? 0) * 2}
      />
    </button>
  );
};

export const DeleteButton = (props: { onClick: () => void }) => {
  return (
    <UIIconButton
      iconName="BIN"
      onClick={() => {
        props.onClick();
      }}
      padding={5}
      width={30}
    />
  );
};

export const BackButton = (props: { onClick: () => void }) => {
  return (
    <UIIconButton
      iconName="CHEVRON-LEFT"
      width={34}
      padding={5}
      onClick={props.onClick}
    />
  );
};

export const VisibilityToggle = (props: {
  isVisible: boolean;
  onToggle: () => void;
}) => {
  return (
    <UIIconButton
      iconName={props.isVisible ? "EYE" : "EYE-CLOSED"}
      width={34}
      padding={6}
      onClick={props.onToggle}
    />
  );
};

export const DragHandle = () => {
  return (
    <UIIconButton
      iconName="DRAG-HANDLE"
      width={34}
      padding={5}
      onClick={() => {}}
    />
  );
};

interface CheckButtonProps {
  onClick: () => void;
  isSelected: boolean;
}

export const CheckButton = (props: CheckButtonProps) => {
  return (
    <button onClick={props.onClick} className={styles.checkButton}>
      <UIIcon
        iconName={props.isSelected ? "CHECK-FILLED" : "CHECK-UNCHECKED"}
        variant="SELECTED"
        size={30}
      />
    </button>
  );
};
